const scrollIntoView = require('scroll-into-view-if-needed').default;
const map = require('./map');

const { FRONT_CONFIG } = window;

// @type {Object<storeId, marker>}
const locationsMap = {};

let selectedStoreId;
let selectedStore;

const storeLocatorContainerSelector = '.store-locator-grid';
let $container;
const elementSelectors = {
  $btnDeselectCountry: '.storelocator-deselect-country',
  $countryField: '#storelocator-country-selector-field',
  $postalCodeInput: '#store-postal-code',
  $countrySelect: '[name="country"]',
  $mapPopUp: '.storelocator-map-popup',
  $tabList: '[href="#store-locator-search-results"]',
  $tabMap: '[href="#storelocator-map"]',
  $searchResultsList: '#store-locator-search-results',
};
const elements = {};

function queryStoreLocatorElements() {
  $container = $(storeLocatorContainerSelector);
  Object.keys(elementSelectors).forEach((key) => {
    elements[key] = $container.find(elementSelectors[key]);
  });
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
  let newUrl = url;
  newUrl +=
    (newUrl.indexOf('?') !== -1 ? '&' : '?') +
    Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
  return newUrl;
}

const countrySelector = {
  hide: function hideCountrySelector() {
    const selectedCountry = elements.$countrySelect.val();
    if (selectedCountry?.length > 0) {
      elements.$countryField.hide();

      elements.$btnDeselectCountry.show();
    }
  },
  reset: function resetCountrySelector() {
    elements.$countrySelect[0].selectedIndex = 0;
    // As it changes programatically, change should be manually triggered
    elements.$countrySelect.change();

    elements.$countryField.show();
    elements.$btnDeselectCountry.hide();
  },
};

function deselectLocation(storeId = selectedStoreId) {
  if (storeId) {
    // Map
    map.updateMarkerIcon(storeId, false);
    elements.$mapPopUp.html('');
    elements.$mapPopUp.hide();
    // List
    $(`#${storeId}`).removeClass('is-selected');
    if (selectedStoreId === storeId) {
      selectedStore = undefined;
      selectedStoreId = undefined;
    }
  }
}

function getStoreId(element) {
  const $storeDetails = $(element).closest('.result').find('.store-details');
  return $storeDetails.data('store-id');
}

function getMapPopUpHtml(mapLocationItem) {
  return `${mapLocationItem.infoWindowHtml}
        <button
            class="btn btn-close store-details__btn-close"
            data-store="${mapLocationItem.id}"
        ><span class="visually-hidden">close</span></button>
        <button
            class="btn btn-ok store-details__btn-ok"
            data-store="${mapLocationItem.id}"
        >${FRONT_CONFIG.global.ok}</button>
    `;
}

function selectLocation(storeId, confirm = false) {
  const $listResult = $(`#${storeId}`);
  if (selectedStoreId !== storeId) {
    deselectLocation(); // Deselect previous location

    const location = locationsMap[storeId];

    // Map
    map.updateMarkerIcon(storeId, true);
    if (!map.isMarkerVisible(storeId)) {
      map.centerMapInStore(storeId);
    }
    elements.$mapPopUp.html(getMapPopUpHtml(location));
    elements.$mapPopUp.show();
    // If using mobile map, wait for the ok button click
    if (
      $container.hasClass('map-show') &&
      elements.$mapPopUp.find('.btn-ok')?.is(':visible') &&
      !confirm
    ) {
      return;
    }

    // List
    $listResult.addClass('is-selected');
    scrollIntoView($listResult[0], {
      block: 'start',
      behavior: 'smooth',
      scrollMode: 'if-needed',
      boundary: elements.$searchResultsList[0],
    });
    selectedStore = location;
    selectedStoreId = storeId;
  }

  $listResult
    .find('input.select-store-input')
    .prop('checked', true)
    .trigger('change');
}

function updateLocationsMap(locations = []) {
  if (!locations) return;
  locations.forEach((loc) => {
    locationsMap[loc.id] = loc;
  });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
  const $resultsDiv = $('.results');
  const $mapDiv = $('.map-canvas');
  const hasResults = data.stores.length > 0;

  if (!hasResults) {
    $('.store-locator-no-results').show();
  } else {
    $('.store-locator-no-results').hide();
  }
  $container.attr('data-has-results', hasResults);
  $('.store-locator__landing').attr('data-has-results', hasResults);

  $resultsDiv
    .empty()
    .data('has-results', hasResults)
    .data('radius', data.radius)
    .data('search-key', data.searchKey);

  updateLocationsMap(JSON.parse(data.locations));
  map.setLocationsData(data.locations);

  if ($mapDiv.data('has-google-api')) {
    map.renderMap(selectLocation, data.centerLocation);
  } else {
    $('.store-locator-no-apikey').show();
  }

  if (data.storesResultsHtml) {
    $resultsDiv.append(data.storesResultsHtml);
    addListenersForToggleStoreOpeningTime();
  }

  scrollIntoView($resultsDiv[0], {
    block: 'start',
    behavior: 'smooth',
    scrollMode: 'if-needed',
    boundary: elements.$searchResultsList[0],
  });
}

function validFormFields(formSelector = '.form.store-locator') {
  const searchTermField = document.querySelector(
    `${formSelector} [name="postalCode"]`
  );
  if (!searchTermField) return false;
  resetFormFieldsValidation(formSelector);

  if (!searchTermField.value) {
    searchTermField.classList.add('is-invalid');
    const invalidFeedback =
      searchTermField.parentElement.querySelector('.invalid-feedback');
    if (invalidFeedback) {
      invalidFeedback.innerHTML = searchTermField.dataset.missingError;
    }
    return false;
  }
  return true;
}

function resetFormFieldsValidation(formSelector = '.form.store-locator') {
  const searchTermField = document.querySelector(
    `${formSelector} [name="postalCode"]`
  );
  if (!searchTermField) return;
  searchTermField.classList.remove('is-invalid');

  const invalidFeedback =
    searchTermField.parentElement.querySelector('.invalid-feedback');
  if (!invalidFeedback) return;
  invalidFeedback.innerHTML = '';
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
async function search(element) {
  if (!validFormFields()) return false;
  const dialog = element.closest('.in-store-inventory-dialog');
  const spinner = dialog.length ? dialog.spinner() : $.spinner();
  spinner.start();
  const $form = element.closest('.store-locator');
  const radius = $('.results').data('radius');
  const url = $form.attr('action');
  // var urlParams = { radius: radius };

  const apiKey = $form.find('[name="apiKey"]').val();
  const countryCodeFromSelect = elements.$countrySelect.val();
  const countryCodeFromSite = FRONT_CONFIG.countryCode;
  const countryCode = countryCodeFromSelect || countryCodeFromSite;

  const addressOrPostalCode = $form.find('[name="postalCode"]').val();

  const location = await map.geocodeAddress(
    addressOrPostalCode,
    countryCode,
    apiKey
  );

  let data;
  let payload;
  if (location !== null) {
    payload = {
      lat: location.lat,
      long: location.lng,
      countryCode,
    };

    // Disable radius filtering, always search from 10km until finding stores
    // url = appendToUrl(url, urlParams);

    data = await $.ajax({
      url,
      type: $form.attr('method'),
      data: payload,
      dataType: 'json',
    });

    data.centerLocation = location;
  } else {
    // Data should be an empty search results and centered on country
    data = {
      centerLocation: await map.geocodeAddress('', countryCode, apiKey),
      locations: '[]',
      radius,
      searchKey: payload,
      stores: [],
    };
  }

  spinner.stop();
  // countrySelector.hide();
  updateStoresResults(data);
  $('body').trigger('store-locator:search-update');

  return false;
}

/* -------------------------------------------------------------------------- *\
 *    Event handlers                                                          *
\* -------------------------------------------------------------------------- */
function handleRadiusChange() {
  const target = $(this);
  deselectLocation();
  const radius = $(target).val();
  const searchKeys = $('.results').data('search-key');
  let url = $(target).data('action-url');
  let urlParams = {};

  if (searchKeys.postalCode) {
    urlParams = {
      radius,
      postalCode: searchKeys.postalCode,
    };
  } else if (searchKeys.lat && searchKeys.long) {
    urlParams = {
      radius,
      lat: searchKeys.lat,
      long: searchKeys.long,
    };
  }

  url = appendToUrl(url, urlParams);
  const dialog = $(target).closest('.in-store-inventory-dialog');
  const spinner = dialog.length ? dialog.spinner() : $.spinner();
  spinner.start();
  $.ajax({
    url,
    type: 'get',
    dataType: 'json',
    success(data) {
      spinner.stop();
      updateStoresResults(data);
      $('.select-store').prop('disabled', true);
    },
  });
}

function handleEventsToSearch(event) {
  event.preventDefault();
  deselectLocation();
  search($(event.target));
}

function addListenersForDetectingLocation() {
  if (!navigator.geolocation) {
    return false;
  }

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  // query geolocation stores
  const queryGeolocationStores = (position) => {
    const $detectLocationButton = $('.detect-location');
    let url = $detectLocationButton.data('action');
    const radius = $('.results').data('radius');
    const urlParams = {
      radius,
      lat: position.coords.latitude,
      long: position.coords.longitude,
    };

    url = appendToUrl(url, urlParams);
    $.ajax({
      url,
      type: 'get',
      dataType: 'json',
      success(data) {
        $.spinner().stop();
        updateStoresResults(data);
        $('body').trigger('store-locator:search-update');
        $('.select-store').prop('disabled', true);
      },
    });
  };

  // on error geolocation
  const hasGeolocationError = () => {};

  // if has geolocation capabilities
  const hasGeolocationSuccess = () => {
    // Enable button and add click event
    $('.detect-location').prop('disabled', false);

    // clicking on detect location.
    $('.detect-location').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $.spinner().start();
      resetFormFieldsValidation();

      navigator.geolocation.getCurrentPosition(
        queryGeolocationStores,
        hasGeolocationError
      );
    });
  };

  // check for geolocation capabilities in the landing stores or devs option in my account orders.
  const page = document.querySelector('.page');
  const isGeolocationPage =
    page?.dataset.action === 'Stores-Find' ||
    page?.dataset.action === 'Account-Orders';

  // also need to check if dropPoints are available
  if (isGeolocationPage || FRONT_CONFIG.isAnyPickupEnabled) {
    navigator.geolocation.getCurrentPosition(
      hasGeolocationSuccess,
      hasGeolocationError,
      options
    );
  }

  return true;
}

function addListenersForSearching() {
  const storeLocatorForm = document.querySelector(
    `${storeLocatorContainerSelector} .form.store-locator`
  );
  if (storeLocatorForm) {
    storeLocatorForm.removeEventListener('submit', handleEventsToSearch);
    storeLocatorForm.addEventListener('submit', handleEventsToSearch);
  }
  const searchButton = document.querySelector(
    `${storeLocatorContainerSelector} .btn-storelocator-search[type="button"]`
  );
  if (searchButton) {
    searchButton.removeEventListener('click', handleEventsToSearch);
    searchButton.addEventListener('click', handleEventsToSearch);
  }

  function handleEnterKeyDown(event) {
    if (event.keyCode === 13) {
      handleEventsToSearch(event);
    }
  }

  elements.$postalCodeInput.on('keydown', handleEnterKeyDown);
}

function addListenersForSelectingStores() {
  $(storeLocatorContainerSelector)
    .off('click', '.js-store-select')
    .on('click', '.js-store-select', (e) => {
      selectLocation(getStoreId(e.target));
    });

  $(storeLocatorContainerSelector)
    .off('click', '.getStoreId')
    .on('click', '.getStoreId', (e) => {
      e.preventDefault();
      const selectedResult = $(':checked', '.results-card .results');
      const data = {
        storeID: selectedResult.val(),
        searchRadius: $('#radius').val(),
        searchPostalCode: $('.results').data('search-key').postalCode,
        storeDetailsHtml: selectedResult
          .siblings('label')
          .find('.store-details')
          .html(),
        event: e,
      };

      $('body').trigger('store:selected', data);
    });
}

function handleMapTabHide() {
  $container.removeClass('map-show');
}

function handleMapTabShown() {
  $container.addClass('map-show');
  map.fitBoundsOnLocations();
}

function addListenersForToggleStoreOpeningTime(parentSelector) {
  const storeOpeningTimesClassName = 'store-opening-times';
  const storeOpeningTimesOpenClassName = `${storeOpeningTimesClassName}--open`;
  const storeOpeningTimesSelector = `.${storeOpeningTimesClassName}`;
  const storeOpeningTimesOpenBtnOpen = `${storeOpeningTimesSelector}__toggler--open`;

  const selector = $(parentSelector || storeLocatorContainerSelector);

  selector
    .off('click', storeOpeningTimesSelector)
    .on('click', storeOpeningTimesSelector, (e) => {
      e.preventDefault();
      e.stopPropagation();
      const storeOpeningTimesContainer = e.target?.closest(
        storeOpeningTimesSelector
      );
      if (e.target?.matches(storeOpeningTimesOpenBtnOpen)) {
        storeOpeningTimesContainer?.classList.add(
          storeOpeningTimesOpenClassName
        );
        return;
      }
      storeOpeningTimesContainer?.classList.remove(
        storeOpeningTimesOpenClassName
      );
    });

  // Reset state of elements
  selector
    .find(`.${storeOpeningTimesOpenClassName}`)
    .removeClass(storeOpeningTimesOpenClassName);
}

module.exports = {
  init() {
    map.init();

    selectedStoreId = undefined;
    selectedStore = undefined;

    queryStoreLocatorElements($(storeLocatorContainerSelector));

    if ($('.map-canvas').data('has-google-api')) {
      updateLocationsMap(map.getLocationsData());
      map.renderMap(selectLocation);
    } else {
      $('.store-locator-no-apikey').show();
    }

    // Hide back button on init
    elements.$btnDeselectCountry?.hide();

    addListenersForDetectingLocation();
    addListenersForSearching();
    addListenersForSelectingStores();
    addListenersForToggleStoreOpeningTime();

    // Radius change (via select element)
    $(`${storeLocatorContainerSelector} .radius`)
      .off('change', handleRadiusChange)
      .on('change', handleRadiusChange);

    // updateSelectStoreButton
    $('body')
      .off('change', '.getStoreId-input')
      .on('change', '.getStoreId-input', () => {
        $('.select-store').prop('disabled', false);
      });

    // On click: reset country and show select
    elements.$btnDeselectCountry?.off('click').on('click', (e) => {
      e.preventDefault();
      countrySelector.reset();
    });

    elements.$countrySelect?.off('change').on('change', () => {
      elements.$postalCodeInput[0].value = '';
    });

    elements.$mapPopUp
      ?.off('click', '.btn-close')
      .on('click', '.btn-close', (e) => {
        deselectLocation($(e.target).data('store'));
      });

    elements.$mapPopUp?.off('click', '.btn-ok').on('click', '.btn-ok', (e) => {
      e.preventDefault();
      selectLocation($(e.target).data('store'), true);
    });

    elements.$tabMap[0]?.removeEventListener('byl:tabs.hide', handleMapTabHide);
    elements.$tabMap[0]?.addEventListener('byl:tabs.hide', handleMapTabHide);

    elements.$tabMap[0]?.removeEventListener(
      'byl:tabs.shown',
      handleMapTabShown
    );
    elements.$tabMap[0]?.addEventListener('byl:tabs.shown', handleMapTabShown);
  },
  selectStore(storeId) {
    selectLocation(storeId);
  },
  getSelectedStore() {
    return selectedStore;
  },
  validFormFields,
  resetFormFieldsValidation,
  addListenersForToggleStoreOpeningTime,
};
